module.exports = __webpack_public_path__ + "img/savings-bubble-7.131891c0.png";